import { Link, useLocation } from "react-router-dom";
import { Home, MessageSquare, HelpCircle, Shield, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const navItems = [{
  label: "Home",
  sectionId: "home",
  icon: Home
}, {
  label: "Testimoni",
  sectionId: "testimoni",
  icon: MessageSquare
}, {
  label: "FAQ",
  sectionId: "faq",
  icon: HelpCircle
}, {
  label: "Garansi",
  sectionId: "garansi",
  icon: Shield
}];
export function Navbar() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const handleNavClick = (sectionId: string) => {
    if (isHomePage) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      // Navigate to home page with section hash
      window.location.href = `/#${sectionId}`;
    }
  };
  return <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-card/80 backdrop-blur-lg">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl gradient-primary">
            <span className="text-lg font-bold text-primary-foreground">D</span>
          </div>
          <div className="flex flex-col">
            <span className="text-lg font-bold text-foreground">UangCuan.ID</span>
            <span className="text-xs text-primary font-medium">Cuan Hemat Maksimal</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map(item => <Button key={item.sectionId} variant="ghost" size="sm" onClick={() => handleNavClick(item.sectionId)} className={cn("gap-2 text-muted-foreground hover:text-foreground hover:bg-muted cursor-pointer")}>
              <item.icon className="h-4 w-4" />
              {item.label}
            </Button>)}
        </nav>

        <div className="flex items-center gap-2">
          <Link to="/track-order" aria-label="Cek Transaksi" className="hidden sm:block">
            <Button variant="outline" size="sm" className="gap-2 flex">
              <Search className="h-4 w-4" />
              Cek Transaksi
            </Button>
          </Link>
          <Link to="/products">
            <Button size="sm" className="gradient-primary text-primary-foreground border-0">
              Lihat Produk
            </Button>
          </Link>
        </div>
      </div>
    </header>;
}